<template>
<div>
  <button  v-if="!loading" type="button" @click="appendDataToModal"  class="btn btn-sm btn-clean btn-icon btn-icon-sm">
    <i class="fas fa-info"></i>
  </button>

    <span v-else class="spinner-border spinner-border-sm"></span>

    <div id="review_modal"  class="modal fade rtl" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <div id="tx_title">
                    </div>
                    <div id="tx_log" class="ml-1">
                    </div>
                    <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                </div>
                <div id="data_sheet" class="modal-body mb-4">
                    <table id="factor_details" class="table table-hover"></table>
                    <table class="table table-hover">
                        <thead>
                        <tr>
                            <th class="table-info" colspan="2">{{ $t('label.review_message') }}</th>
                        </tr>
                        </thead>
                        <tbody id="tr_details">
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import { i18n } from '@/plugins/i18n'
import { ticketService } from '../../../common/api.service';
import toastr from "toastr";
import { AuthorizationHeader } from '@/common/jwt.service'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            data: {},
            loading: false,
            isError: false,
        }
},

    methods: {
        des() {},
        dataArray() {
            let obj = this.row.description
            let obj_array = []
            let key, value
            for ([key, value] of Object.entries(obj)) {
                obj_array[key] = value
            }
            return obj_array
        },
        async appendDataToModal() {
            this.loading = true;
        
            const currentPageRows = this.datatable.originalDataSet || [];
            const found = currentPageRows.find(t => t.id === this.row.id);
        
            if (!found) {
                this.isError = true;
                this.toastr.error(i18n.t('message.ticket_not_found'));
                this.loading = false;
                return;
            }
        
            this.data = found;
            this.loading = false;
        
            $("#review_modal").modal('show');
        
            let tr_details = $('#tr_details').empty();
            let tx_title = $('#tx_title').empty();
        
            let ps_elements = `<h4 class="modal-title float-left p-0 m-0"> تیکت ${this.row.id}</h4>`;
            tx_title.append(ps_elements);
        
            if (this.data.feedback && typeof this.data.feedback === 'object') {
                for (const [key, value] of Object.entries(this.data.feedback)) {
                    tr_details.append(`
                        <tr>
                            <td class="font-weight-bold">${this.formatKey(key)}</td>
                            <td>${value}</td>
                        </tr>
                    `);
                }
            } else if (this.data.feedback) {
                tr_details.append(`<tr><td colspan="2">${this.data.feedback}</td></tr>`);
            } else {
                tr_details.append('<tr><td colspan="2">نظری یافت نشد.</td></tr>');
            }
        },

        formatKey(key) {
            return key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
        }
    },
})
</script>

<style>

</style>
